import { mooberApiV2 as apiV2 } from '@/api/mooberApi';
import axios from 'axios';

const inviteCompany = ({ companyId, invitedCompanyId }) => axios.post(`invitation/company/${companyId}/carrierDispatchNetwork`, { invitedCompanyId });
const acceptInvitation = inviteId => axios.post(`invitation/carrierDispatchNetwork/${inviteId}`, {});
const refuseInvitation = inviteId => axios.delete(`invitation/carrierDispatchNetwork/${inviteId}`);
const getCompanyCDNs = ({ companyId }) => axios.get(`company/${companyId}/carrierDispatchNetwork`);
const removeMember = ({ companyId, memberCompanyId }) => axios.delete(`company/${companyId}/carrierDispatchNetwork/${memberCompanyId}`);
const getDashboard = ({ companyId }) => axios.get(`simpleDashboard/${companyId}/dispatchedLoads`);
const getDashboardV2 = ({ companyId }) => apiV2.get(`companyDashboard/${companyId}/dispatchedLoads`);
const acceptAssigment = (dispatchId, load) => axios.post(`dispatch/${dispatchId}/accept`, load);
const followAssigment = dispatchId => axios.post(`dispatch/${dispatchId}/follow`, {});
const unFollowAssigment = dispatchId => axios.post(`dispatch/${dispatchId}/unfollow`, {});
const cancelAssigment = dispatchId => axios.delete(`dispatch/${dispatchId}`);
const acknowledgePayment = ({ dispatchId, body }) => axios.post(`dispatch/${dispatchId}/acknowledgePayment`, body);
const getDispatch = (humanId, companyId) => apiV2.get(`/companyDashboard/${companyId}/dispatchedLoads/${humanId}`);

export default {
  inviteCompany,
  acceptInvitation,
  refuseInvitation,
  getCompanyCDNs,
  removeMember,
  getDashboard,
  getDashboardV2,
  acceptAssigment,
  cancelAssigment,
  acknowledgePayment,
  followAssigment,
  unFollowAssigment,
  getDispatch,
};



// WEBPACK FOOTER //
// ./src/api/dispatchers.js